<template>
  <el-dialog
    title="添加分享商品属性"
    center
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <selectInfo v-if="curName == 'selectInfo'"></selectInfo>
  </el-dialog>
</template>
<script>
import selectInfo from "./selectInfo.vue";

export default {
  components: {
    selectInfo,
  },
  data() {
    return {
      curName: "selectInfo",
      dialogVisible: true,
    };
  },
  methods: {
    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("close", {
          type: "success",
          openDialog: false,
        });
      } else {
        this.$emit("close", {
          type: "error",
          openDialog: false,
        });
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sharepolite/addGoods/index.vue